import { alerts } from '../actionTypes/alerts';

const startUpdateAlert = payload => ({
  type: alerts.START_UPDATE_ALERT,
  payload
});
const successUpdateAlert = payload => ({
  type: alerts.SUCCESS_UPDATE_ALERT,
  payload
});

const errorUpdateNote = payload => ({
  type: alerts.FAILURE_UPDATE_ALERT,
  payload
});

export const updateAlert = (requests, callback) => dispatch => {
  dispatch(startUpdateAlert());
  dispatch({
    hmsFetchConfig: {
      path: '/hms_ms/api/v1/generic',
      method: 'POST',
      body: {
        data_tag: 'DATATAG_G6_DELIGHTIQ_UPDATE_ALERT',
        request_data: {
          requests
        }
      }
    },

    onSuccess: alert_response => {
      dispatch(successUpdateAlert({ alert_response }));
      if (callback) callback(true);
    },

    onError: ({ error }) => {
      dispatch(errorUpdateNote({ error }));
    }
  });
};